import { defineStore } from "pinia";
import state from "./state";
import actions from "./actions";
import getters from "./getters";

export const useLivelihoodQuestionnaireStore = defineStore(
  "livelihoodQuestionnaire",
  {
    state,
    getters,
    actions: actions(),
  }
);
